(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { forwardRef } from 'react';
import { FormControl, InputLabel, OutlinedInput, Select as MuiSelect, MenuItem, Checkbox, ListItemText, ListSubheader } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { media } from "../../helpers/responsive";
import { Field } from "../forms"; // TODO: Implement label position in themes. Compact vs. not?
// const labelPositions = ['above', 'left', 'outlined', 'infield'];
// const labelPosition = labelPositions[2];
// TODO: Should be using native select for mobile and tablet,
// the only issue is supporting optgroup
// eslint-disable-next-line

var Select = forwardRef(__signature__(function (props, ref) {
  var label = props.label,
      onChange = props.onChange,
      options = props.options,
      value = props.value,
      disabled = props.disabled,
      onBlur = props.onBlur,
      multiple = props.multiple,
      displayEmpty = props.displayEmpty,
      renderValue = props.renderValue,
      testSelector = props.testSelector,
      name = props.name,
      fullWidth = props.fullWidth,
      helpText = props.helpText,
      SelectProps = props.SelectProps,
      error = props.error,
      rest = _objectWithoutProperties(props, ["label", "onChange", "options", "value", "disabled", "onBlur", "multiple", "displayEmpty", "renderValue", "testSelector", "name", "fullWidth", "helpText", "SelectProps", "error"]);

  var inputLabel = React.useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  React.useEffect(function () {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  var handleChange = function handleChange(e) {
    var v = e.target.value; // Catch click events on optgroup, which would trigger onChange event
    // with value undefined or [...values, undefined].

    if (multiple && v.length && v[v.length - 1] === undefined) {
      return;
    } else if (!multiple && v === undefined) {
      return;
    }

    onChange(e);
  }; // Use native if mobile and no optgroups


  var useNative = props["native"] || media.matches.mobile.only() && !options.find(function (o) {
    return o.options;
  });
  var useRenderValue = renderValue ? renderValue : // : useNative
  !multiple ? function (renderValue) {
    var _options$find;

    return (_options$find = options.find(function (o) {
      return o.value === renderValue;
    })) === null || _options$find === void 0 ? void 0 : _options$find.text;
  } : function () {
    var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return selected.map(function (item) {
      var _options$find2;

      return (_options$find2 = options.find(function (o) {
        return o.value === item;
      })) === null || _options$find2 === void 0 ? void 0 : _options$find2.text;
    }).join(', ');
  };
  var inputRef = ref ? {
    inputRef: ref
  } : {};
  return React.createElement(FormControl, _extends({
    variant: "outlined",
    disabled: Boolean(disabled),
    onBlur: onBlur,
    fullWidth: fullWidth,
    style: props.style
  }, rest), label ? React.createElement(InputLabel, {
    ref: inputLabel
  }, label) : null, React.createElement(MuiSelect, _extends({}, inputRef, {
    displayEmpty: displayEmpty,
    "native": useNative ? value : undefined,
    value: value,
    name: name,
    renderValue: useRenderValue,
    onChange: handleChange,
    multiple: multiple,
    inputProps: {
      'data-test-selector': testSelector || name
    },
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        horizontal: 0,
        vertical: -4
      }
    },
    input: label ? React.createElement(OutlinedInput, {
      labelWidth: labelWidth
    }) : null
  }, SelectProps || {}, {
    error: error
  }), options.map(function (option) {
    return useNative ? option.options ? React.createElement("optgroup", {
      key: option.value,
      label: option.text,
      disabled: Boolean(option.disabled)
    }, option.options.map(function (subOption) {
      return React.createElement("option", {
        key: "".concat(option.value, ".").concat(subOption.value),
        value: "".concat(option.value, ".").concat(subOption.value),
        disabled: Boolean(option.disabled || subOption.disabled),
        selected: value instanceof Array ? value.indexOf("".concat(option.value, ".").concat(subOption.value)) !== -1 : value === "".concat(option.value, ".").concat(subOption.value)
      }, subOption.text);
    })) : React.createElement("option", {
      key: option.value,
      value: option.value,
      disabled: Boolean(option.disabled)
    }, option.text) : !multiple ? React.createElement(MenuItem, {
      key: option.value,
      value: option.value,
      disabled: Boolean(option.disabled)
    }, React.createElement(ListItemText, {
      primary: option.text
    })) : option.options ? [React.createElement(ListSubheader, {
      disableSticky: true,
      key: option.text
    }, option.text), option.options.map(function (subOption) {
      return React.createElement(MenuItem, {
        key: "".concat(option.value, ".").concat(subOption.value),
        value: "".concat(option.value, ".").concat(subOption.value),
        disabled: Boolean(option.disabled || subOption.disabled)
      }, React.createElement(Checkbox, {
        color: "secondary",
        checked: value instanceof Array ? value.indexOf("".concat(option.value, ".").concat(subOption.value)) !== -1 : value === "".concat(option.value, ".").concat(subOption.value)
      }), React.createElement(ListItemText, {
        primary: subOption.text
      }));
    })] : React.createElement(MenuItem, {
      key: option.value,
      value: option.value,
      disabled: Boolean(option.disabled)
    }, React.createElement(Checkbox, {
      checked: value instanceof Array ? value.indexOf(option.value) !== -1 : value === option.value
    }), React.createElement(ListItemText, {
      primary: option.text
    }));
  })));
}, "useRef{inputLabel}\nuseState{[labelWidth, setLabelWidth](0)}\nuseEffect{}"));
Select.propTypes = {
  "native": PropTypes.bool,
  fullWidth: PropTypes.bool,
  helpText: PropTypes.string,
  error: PropTypes.bool
};
Select.defaultProps = {
  options: [],
  multiple: false,
  displayEmpty: false,
  disabled: false,
  "native": undefined,
  fullWidth: false,
  helpText: null,
  error: false
};

var _default = withTheme(Select);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Select, "Select", "/home/vsts/work/1/s/src/components/inputs/Select.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/Select.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();